export default __webpack_public_path__ + "static/media/Head_6_Ear_2_C4.18ab6249.svg";